import { useEffect, useState } from 'react'
import type { Bet } from 'src/types/domain/Bet'
import { isMarbleGame } from 'src/types/domain/Game'
import { useGetCurrentGame } from 'src/store/game'
import { useBetActions, useBetStore } from 'src/store/bet'

export const useGetCurrentBets = () => {
  const game = useGetCurrentGame()
  const [currentBets, setCurrentBets] = useState<Bet[]>([])
  const betActions = useBetActions()

  const currentRace = isMarbleGame(game) ? game.races[0] : undefined
  const currentRaceId = currentRace?.uuid

  useEffect(() => {
    const unsubscribe = useBetStore.subscribe(
      (state) => state.bets,
      (bets) => {
        const raceBets = bets.allIds
          .map((id) => bets.byId[id])
          .filter((bet): bet is Bet => bet !== undefined && bet.raceId === currentRaceId)

        setCurrentBets(raceBets)
      },
      { fireImmediately: true }
    )

    return unsubscribe
  }, [currentRaceId])

  useEffect(() => {
    if (currentRaceId) {
      const bets = betActions.getBetsByRaceId(currentRaceId)
      setCurrentBets(bets)
    }
  }, [currentRaceId, betActions])

  return { currentBets }
}
